import React from "react";
import { Link } from "react-router-dom";

import { IgButton, IgDivider, IgTypography } from "@intelligems/ig-theme";
import { ExperienceDto } from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

import { AnalyticStatusChip } from "../../../../components/chips/analyticsStatusChip";
import { DASHBOARD_ROUTES } from "../../../../routes/routes";
import { dateTimeConverter } from "../../../../utils/dateConverters";
import { mpClickAnalyticsButton } from "../../../../utils/mixpanel";

interface NewActiveTestProps {
  experience: ExperienceDto;
  isLastInList: boolean;
}

const PREFIX = "ActiveTest";

const classes = {
  bigText: `${PREFIX}-bigText`,
  littleText: `${PREFIX}-littleText`,
};

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`& .${classes.bigText}`]: {
    fontWeight: 600,
    fontSize: "18px",
    letterSpacing: "0.5px",
  },

  [`& .${classes.littleText}`]: {
    fontSize: "14px",
    letterSpacing: "0.5px",
  },
}));

export const NewActiveTest = ({
  experience,
  isLastInList,
}: NewActiveTestProps) => {
  return (
    <StyledGrid item container direction={"column"}>
      <Grid
        key={experience.id}
        xs
        container
        item
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Grid container item direction={"column"} xs={6}>
          <Grid item>
            <IgTypography className={classes.bigText}>
              {experience.name}
            </IgTypography>
          </Grid>
          <Grid item>
            <IgTypography className={classes.littleText}>
              Started {dateTimeConverter(experience.startedAtTs)}
            </IgTypography>
          </Grid>
        </Grid>
        <Grid item>
          <AnalyticStatusChip experience={experience} />
        </Grid>
        <Grid item>
          <Link
            style={{ textDecoration: "none", color: "black" }}
            onClick={() => {
              mpClickAnalyticsButton(
                experience.name,
                experience.id!,
                "Live test impact details button"
              );
            }}
            to={`${
              DASHBOARD_ROUTES.Dashboard_Overview
            }?experienceId=${experience.id!}`}
          >
            <IgButton>View Details</IgButton>
          </Link>
        </Grid>
      </Grid>
      {!isLastInList && <IgDivider spacing={"s"} />}
    </StyledGrid>
  );
};
